import t from"react";import{ProductAlert as o}from"./ProductAlert.js";const e=({notificationText:e,tooltipText:r,...i})=>t.createElement(o,{...i,type:"warning",title:e,tooltipContent:r});export{e as CustomerExclusiveProductAlert};
